<template>
  <div>
    <FilledBanner
      title="全球雇佣指南"
      subtitle="让你轻松实现150+国家的远程雇佣"
      bg-image="https://video.reta-inc.com/image/default/5CEE755C3DA2466DB1F1BE6969A3BF25-6-2.jpg"
    />
    <div class="main">
      <div class="tabs">
        <div
          class="tab"
          v-for="area in data?.areaList"
          :key="area.id"
          :class="{ active: area.attributes.enName === activeTab }"
          @click="onTabClick(area.attributes.enName)"
        >
          {{ area.attributes.cnName }}
        </div>
      </div>
      <div
        class="country-list"
        v-for="area in data?.areaList"
        :key="area.attributes.enName"
        v-show="area.attributes.enName === activeTab"
      >
        <nuxt-link
          class="country"
          v-for="country in data?.list?.filter(
            item => item.attributes.area.data.attributes.enName === area.attributes.enName
          )"
          :key="country.id"
          :to="country.url"
        >
          <div class="hover_box">
            <button class="go_detail">查看详情</button>
          </div>
          <img
            class="country__cover"
            :src="`https://jkqj-assets-beijing.oss-cn-beijing.aliyuncs.com/global/covers/${country?.attributes?.country.data.attributes.shortCode}.jpg`"
          />
          <div class="country__content">{{ country.attributes.country.data.attributes.cnName }}</div>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { IEntity, IList } from '@/@types/cms';
import { IArea, IGlobalRecruitment } from '@/@types/entities';
useSeoHead();

const { data, refresh } = await useAsyncData(async () => {
  const { data } = await useFetch<IList<IGlobalRecruitment>>(`/api/global/list`);
  const list = data.value?.data.map(item => ({
    ...item,
    url: `/resource/global/${item.attributes.country.data.attributes.name}`,
  }));
  const areaList = list?.reduce((res, item) => {
    const itemArea = item.attributes.area.data;
    if (res.findIndex(area => area.id === itemArea.id) < 0) {
      res.push(itemArea);
    }
    return res;
  }, [] as IEntity<IArea>[]);
  return {
    list,
    areaList,
  };
});

const activeTab = ref(data.value?.areaList?.[0].attributes.enName);
async function onTabClick(name: string) {
  activeTab.value = name;
}
</script>
<style lang="less" scoped>
@media screen and (min-width: 800px) {
  .main {
    margin: -40px auto 60px;
    width: 1280px;
    padding: 0 32px;

    .arco-pagination {
      justify-content: center;
      margin-top: 40px;
    }
  }

  .tabs {
    height: 120px;
    background: #ffffff;
    box-shadow: 0px 4px 32px rgba(135, 172, 255, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    .tab {
      height: 60px;
      padding: 16px 40px;
      box-sizing: border-box;
      font-size: 20px;
      line-height: 28px;
      color: #4e5969;
      cursor: pointer;

      &:hover {
        color: #386aff;
      }

      &.active {
        color: #386aff;
        background: rgba(22, 93, 255, 0.1);
        border-radius: 12px;
      }

      & + .tab {
        margin-left: 40px;
      }
    }
  }

  .country-list {
    margin-top: 60px;
    width: 100%;
    display: grid;
    grid-template-columns: 400px 400px 400px;
    grid-template-rows: 300px;
    grid-row-gap: 40px;
    grid-column-gap: 40px;

    .country {
      background: #ffffff;
      box-shadow: 0px 4px 16px rgba(135, 172, 255, 0.2);
      border-radius: 12px;
      height: 300px;
      box-sizing: border-box;
      overflow: hidden;
      text-decoration: none;
      position: relative;

      &__cover {
        width: 400px;
        height: 240px;
        display: block;
      }

      &__content {
        font-size: 20px;
        line-height: 26px;
        color: #1d2129;
        height: 60px;
        text-align: center;
        line-height: 60px;
      }

      &:hover {
        .country__content {
          color: #165dff;
        }
      }

      .hover_box {
        display: none;
      }

      &:hover .hover_box {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100% - 60px);
        border-radius: 12px;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4));
        display: flex;
        justify-content: center;
        align-items: center;

        .go_detail {
          border: 1px solid #ffffff;
          border-radius: 24px;
          font-weight: 400;
          font-size: 20px;
          line-height: 26px;
          text-align: center;
          letter-spacing: 0.01em;
          color: #ffffff;
          background-color: transparent;
          padding: 12px 30px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 800px) {
  .main {
    .arco-pagination {
      justify-content: center;
      margin: 40px auto;
    }
  }

  .tabs::-webkit-scrollbar {
    display: none;
  }

  .tabs {
    max-width: 100%;
    overflow-x: auto;
    position: sticky;
    top: 70px;
    z-index: 10;
    padding: 8px 16px;
    background: #ffffff;
    box-shadow: 0px 4px 4px rgba(135, 172, 255, 0.1);
    display: flex;
    align-items: center;
    gap: 4px;

    .tab {
      padding: 6px 12px;
      box-sizing: border-box;
      font-weight: 500;
      font-size: 14px;
      line-height: 28px;
      letter-spacing: 0.02em;
      color: #4e5969;
      white-space: nowrap;

      &.active {
        color: #386aff;
        background: rgba(22, 93, 255, 0.1);
        border-radius: 6px;
      }
    }
  }

  .country-list {
    // background: #dfdfdf;
    padding: 20px 16px 0;
    display: grid;
    grid-template-columns: repeat(2, 48%);
    justify-content: space-between;
    row-gap: 16px;

    .country {
      background: #ffffff;
      box-shadow: 0px 4px 4px rgba(135, 172, 255, 0.1);
      border-radius: 4px;
      // height: 300px;
      box-sizing: border-box;
      overflow: hidden;
      text-decoration: none;
      position: relative;

      &__cover {
        width: 100%;
        height: 98px;
        display: block;
      }

      &__content {
        font-size: 14px;
        line-height: 14px;
        text-align: center;
        letter-spacing: 0.01em;
        color: #1d2129;
        padding: 11px 0;
      }

      // &:hover {
      //   .country__content {
      //     color: #165dff;
      //   }
      // }

      .hover_box {
        display: none;
      }

      // &:hover .hover_box {
      //   display: block;
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: calc(100% - 60px);
      //   border-radius: 12px;
      //   background: linear-gradient(
      //     0deg,
      //     rgba(0, 0, 0, 0.4),
      //     rgba(0, 0, 0, 0.4)
      //   );
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;

      //   .go_detail {
      //     border: 1px solid #ffffff;
      //     border-radius: 24px;
      //     font-weight: 400;
      //     font-size: 20px;
      //     line-height: 26px;
      //     text-align: center;
      //     letter-spacing: 0.01em;
      //     color: #ffffff;
      //     background-color: transparent;
      //     padding: 12px 30px;
      //     cursor: pointer;
      //   }
      // }
    }
  }
}
</style>
